/*
  INSERT INTO _40rs (_key, _icn, _pfx, _who, _dtm, "createdAt", "updatedAt")
  VALUES (2030, '2030', 'エントリー', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _40rs (_key, _icn, _pfx, _who, _dtm, "createdAt", "updatedAt")
  VALUES (2040, '2040', 'エントリー抽選', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _40rs (_key, _icn, _pfx, _who, _dtm, "createdAt", "updatedAt")
  VALUES (2050, '2050', '直接予約', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _40rs (_key, _icn, _pfx, _who, _dtm, "createdAt", "updatedAt")
  VALUES (2060, '2060', '使用状況', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _40rs (_key, _icn, _pfx, _who, _dtm, "createdAt", "updatedAt")
  VALUES (2070, '2070', '実績集計', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _40rs (_key, _icn, _pfx, _who, _dtm, "createdAt", "updatedAt")
  VALUES (2090, '2090', 'サイネージ', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
*/

export const _40z = {
  _40r: { // 機能情報
    v0: {
      fldz: {
      },
    },
  },
};
